module.exports = __webpack_public_path__ + "media/assets/white-mail-5b656758e3ffe3adfb3f183ca0961a60ffae197e41f8fa1e45fef91e73bcb70f.svg";